'use client';

import Image from 'next/image';

const VERIFIED_BLUE = '#1A1A4B';

interface VerifiedBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

export function VerifiedBadge({ 
  size = 'md', 
  showText = true,
  className = '' 
}: VerifiedBadgeProps) {
  const sizeMap = {
    // Slightly smaller verified badge (per design)
    sm: { badge: 28, title: 'text-xs', subtitle: 'text-[11px]' },
    md: { badge: 38, title: 'text-xs', subtitle: 'text-[11px]' },
    lg: { badge: 52, title: 'text-sm', subtitle: 'text-xs' },
  };
  
  const { badge: badgeSize, title: titleSize, subtitle: subtitleSize } = sizeMap[size];

  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`}>
      <Image
        src="/only-verified-badge.png"
        alt="Verified Freight Forwarder"
        width={badgeSize}
        height={badgeSize}
        className="flex-shrink-0"
      />
      {showText && (
        <div className="flex flex-col leading-tight">
          <span className={`font-semibold ${titleSize}`} style={{ color: VERIFIED_BLUE }}>
            Verified
          </span>
          <span className={`${subtitleSize}`} style={{ color: VERIFIED_BLUE }}>
            Freight Forwarder
          </span>
        </div>
      )}
    </div>
  );
}

// Full badge with text - matches the original design
export function VerifiedBadgeFull({ className = '' }: { className?: string }) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <Image
        src="/only-verified-badge.png"
        alt="Verified Freight Forwarder"
        width={60}
        height={60}
        className="flex-shrink-0"
      />
      <div className="flex flex-col">
        <span className="font-semibold text-sm leading-tight" style={{ color: VERIFIED_BLUE }}>
          Verified
        </span>
        <span className="text-xs leading-tight" style={{ color: VERIFIED_BLUE }}>
          Freight Forwarder
        </span>
      </div>
    </div>
  );
}
